import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import { Message } from 'element-ui'

import ProjectTable from '../views/ProjectTable.vue'

import LoginPage from '../views/LoginPage.vue'
import Portal from '../views/PortalPage.vue'
import { resolveAuthToken } from '../utils/auth'
import { setMenuPermissions } from '../utils/menuPermission'
import { getApiData, getApiPayload, isApiSuccess } from '../utils/apiResult'

const BUSINESS_ROUTE_PREFIXES = [
  '/crm-index',
  '/srm-index',
  '/asset-index',
  '/kms-index',
  '/finance-index',
  '/book-index',
  '/expo-index'
]

function isBusinessRoute(path) {
  if (!path) return false
  return BUSINESS_ROUTE_PREFIXES.some(prefix => path === prefix || path.startsWith(prefix + '/'))
}

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    redirect: '/portal'
  },

  {
    path: '/project-table',
    name: 'ProjectTable',
    component: ProjectTable
  },
  {
    path:'/login',
    component:LoginPage
  },
  {
    path: '/dingtalk-entry',
    component: () => import('@/views/DingTalkWorkbenchLogin.vue')
  },
  {
    path: '/forgot-password',
    component: () => import('@/views/ForgotPassword.vue')
  },
  
  {
    path:'/portal',
    component:Portal
  },
  {
    path: '/portal/notices',
    component: () => import('@/views/PortalNoticeList.vue')
  },
  {
    path: '/portal/approvals',
    component: () => import('@/views/WorkflowApprovalTasks.vue')
  },
  {
    path: '/srm-index',
    component: () => import('@/views/SrmIndex.vue'),
    children: [
      { path: '', component: () => import('@/views/SrmHome.vue') },
      { path: 'srm-supplier', component: () => import('@/views/SrmSupplier.vue') }
    ]
  },
  {
    path: '/kms-index',
    component: () => import('@/views/KmsIndex.vue'),
    redirect: '/kms-index/documents',
    children: [
      { path: 'documents', component: () => import('@/views/KmsDocuments.vue') }
    ]
  },
  {
    path: '/book-index',
    component: () => import('@/views/BookIndex.vue')
  },
  {
    path: '/book-index/scan/:token',
    component: () => import('@/views/BookIndex.vue')
  },
  {
    path: '/asset-index',
    component: () => import('@/views/AssetIndex.vue'),
    children: [
      { path: '', component: () => import('@/views/AssetDashboard.vue') },
      { path: 'office', component: () => import('@/views/AssetList.vue'), meta: { title: '资产清单', assetScope: 'ledger' } },
      { path: 'overseas', redirect: '/asset-index/office' },
      { path: 'gift', component: () => import('@/views/AssetList.vue'), meta: { title: '礼品资产', assetType: 'gift' } },
      { path: 'gift-usage-history', component: () => import('@/views/GiftAssetUsageHistory.vue') },
      { path: 'software', redirect: '/asset-index/office' },
      { path: 'reports', component: () => import('@/views/AssetList.vue'), meta: { title: '资产报表', report: true } }
    ]
  },
  {
    path: '/crm-index',
    component: () => import('@/views/CrmIndex.vue'),
    children: [
      { path: '', component: () => import('@/views/CrmHome.vue') },
      { path: 'crm-customer', component: () => import('@/views/CrmCustomer.vue') },
      { path: 'crm-customer-add', component: () => import('@/views/CrmCustomerAdd.vue') },
      { path: 'crm-lead', component: () => import('@/views/CrmLead.vue') },
      { path: 'crm-lead-add', component: () => import('@/views/CrmLeadAdd.vue') },
      { path: 'crm-opportunity', component: () => import('@/views/CrmOpportunity.vue') },
      { path: 'crm-project', component: () => import('@/views/CrmProject.vue') },
      { path: 'crm-contract', component: () => import('@/views/CrmContract.vue') },
      { path: 'crm-receipt', component: () => import('@/views/CrmReceipt.vue') },
      { path: 'crm-contract-add', component: () => import('@/views/CrmContractAdd.vue') },
      { path: 'crm-quote', component: () => import('@/views/CrmQuote.vue') },
      { path: 'crm-bid', component: () => import('@/views/CrmBid.vue') },
      {
        path: 'crm-lead-list',
        component: () => import('@/views/CrmLeadList.vue')
      },
      {
        path: 'crm-opportunity-list',
        component: () => import('@/views/CrmOpportunityList.vue')
      },
      {
        path: 'crm-project-list',
        component: () => import('@/views/CrmProjectList.vue')
      }
    ]
  },
  {
    path: "/admin/login",
    component: () => import("@/views/AdminLogin.vue")
  },
  {
    path: "/admin/portal-page",
    component: () => import("@/views/AdminPortalPage.vue")
  },
  {
    path: "/admin/employee",
    component: () => import("@/views/AdminEmployee.vue")
  },
  {
    path: "/admin/department",
    component: () => import("@/views/AdminDepartment.vue")
  },
  {
    path: "/admin/role",
    component: () => import("@/views/AdminRole.vue")
  },
  {
    path: "/admin/post",
    component: () => import("@/views/AdminPosition.vue")
  },
  {
    path: "/admin/menu-permission",
    component: () => import("@/views/AdminMenuPermission.vue")
  },
  {
    path: "/admin/geo-locale",
    component: () => import("@/views/AdminGeoLocale.vue")
  },
  {
    path: "/admin/flow-config",
    component: () => import("@/views/AdminApprovalFlow.vue")
  },
  {
    path: "/admin/notice",
    component: () => import("@/views/AdminNoticeIndex.vue"),
    redirect: "/admin/notice/publish",
    children: [
      { path: "publish", component: () => import("@/views/AdminNoticePublish.vue") },
      { path: "manage", component: () => import("@/views/AdminNoticeManage.vue") }
    ]
  },
  {
    path: "/admin/recycle-bin",
    component: () => import("@/views/AdminRecycleBin.vue")
  },
  {
    path: "/admin/verification-config",
    component: () => import("@/views/AdminVerificationConfig.vue")
  },
  {
    path: "/admin/log-center",
    component: () => import("@/views/AdminLogCenter.vue")
  }


]

function isChunkLoadError(err) {
  const msg = String((err && err.message) || err || "")
  return /Loading chunk .* failed/i.test(msg) || err && err.name === "ChunkLoadError"
}

function reloadForStaleChunk() {
  if (window.__portalChunkReloading) return
  window.__portalChunkReloading = true
  window.location.reload()
}

// 去除路由重复访问报错；懒加载 chunk 失败时自动刷新（常见于 Electron 缓存了旧版 index.html）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === "NavigationDuplicated") return err
    if (isChunkLoadError(err)) {
      reloadForStaleChunk()
      return err
    }
    console.error("[router.push]", err)
    return err
  })
}

const router = new VueRouter({
  routes
})

const PORTAL_PAGE_TITLE = 'arishein-portal'
const ADMIN_PAGE_TITLE = '后台管理'

/** 后台与门户共用同一套前端时，按路由区分浏览器标签页标题。 */
router.afterEach(to => {
  document.title = to.path.startsWith('/admin') ? ADMIN_PAGE_TITLE : PORTAL_PAGE_TITLE
})

router.onError(err => {
  if (isChunkLoadError(err)) reloadForStaleChunk()
})

async function ensureMenuPermissions(token) {
  try {
    const res = await axios.get('/api/portal/my/menus', {
      headers: { Authorization: 'Bearer ' + token }
    })
    const body = getApiPayload(res)
    if (isApiSuccess(body)) {
      setMenuPermissions(getApiData(body) || [])
    }
  } catch (e) {
    setMenuPermissions([])
  }
}

async function checkRoutePermission(routePath, token) {
  try {
    const res = await axios.get('/api/portal/my/permission/check', {
      params: { routePath },
      headers: { Authorization: 'Bearer ' + token }
    })
    const body = getApiPayload(res)
    if (isApiSuccess(body) && getApiData(body)) {
      return getApiData(body)
    }
  } catch (e) {
    /* ignore */
  }
  return { canView: false, canEdit: false, fallbackRoute: null, message: '暂无权限访问该页面' }
}

router.beforeEach(async (to, from, next) => {
  const adminToken = localStorage.getItem("adminToken")
  /** 与 axios 一致：门户/CRM 任一端登录即可访问业务路由 */
  const portalJwt = resolveAuthToken(false)

  // 普通用户白名单
  const userWhiteList = ["/login", "/forgot-password", "/dingtalk-entry"]

  // 管理员白名单
  const adminWhiteList = ["/admin/login"]

  // 判断是否管理员模块
  const isAdminRoute = to.path.startsWith("/admin")

  if (isAdminRoute) {
    // 管理员路由
    if (adminWhiteList.includes(to.path)) {
      // 如果已经登录管理员，再去登录页就直接跳后台首页
      if (adminToken) {
        next("/admin/portal-page")
      } else {
        next()
      }
    } else {
      // 非登录页，需要管理员token
      if (adminToken) {
        next()
      } else {
        next("/admin/login")
      }
    }
  } else {
    // 普通用户路由
    if (userWhiteList.includes(to.path)) {
      if (to.path === '/dingtalk-entry') {
        next()
        return
      }
      // 如果普通用户已登录，再去登录页可直接进门户
      if (portalJwt) {
        next(typeof to.query.redirect === 'string' && to.query.redirect.startsWith('/') ? to.query.redirect : "/portal")
      } else {
        next()
      }
    } else {
      if (portalJwt) {
        if (isBusinessRoute(to.path)) {
          await ensureMenuPermissions(portalJwt)
          const permission = await checkRoutePermission(to.path, portalJwt)
          if (!permission.canView) {
            if (permission.fallbackRoute && permission.fallbackRoute !== to.path) {
              next(permission.fallbackRoute)
              return
            }
            Message.warning(permission.message || '暂无权限访问该页面')
            next('/portal')
            return
          }
        }
        next()
      } else {
        next({ path: "/login", query: { redirect: to.fullPath } })
      }
    }
  }
})
export default router
